import { render } from "./TrimInfoModal.vue?vue&type=template&id=c200d37e"
import script from "./TrimInfoModal.vue?vue&type=script&lang=js"
export * from "./TrimInfoModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__